/** @format */

import React, { FC, ReactElement, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import I18n from '../../../components/Translate/I18n';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import CustomInputExt from '../../../components/CustomInput/CustomInputExt';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { useDispatch } from 'react-redux';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { configDefault } from '../../../core/config';
import { ApnNameInterface, ApnNamePostInterface } from '../../../interfaces/collections/ApnNameInterface';
import { NotificationHelper } from '../../../helpers/NotificationHelper';

type PlatformResellerAddApnNameType = {
    open: boolean;
    platformResellerId: number;
    isPublic: boolean;
    reload(): void;
    closed(): void;
};

export const PlatformResellerAddApnName: FC<PlatformResellerAddApnNameType> = ({
    isPublic,
    open,
    platformResellerId,
    reload,
    closed,
}): ReactElement => {
    const dispatch = useDispatch();
    const [apnName, setApnName] = useState<string | null>(null);

    const addNew = (): void => {
        if (apnName === null || apnName.length === 0) {
            NotificationHelper.notifyError('pools:apn.empty_name', dispatch);
            return;
        }
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/apn_names', configDefault.PLATFORM_API_PREFIX)),
            'add-new-apn-name',
            {
                platformResellerId: platformResellerId,
                isPublic: isPublic,
                apnName: apnName,
            } as ApnNamePostInterface,
            {
                onSuccess: (data: ApnNameInterface): void => {
                    NotificationHelper.notifySaveSuccess(dispatch);
                    reload();
                    closed();
                },
                onError: (data: {
                    message: {
                        message?: string | null;
                    };
                }): void => {
                    if (data.message && data.message.message) {
                        NotificationHelper.notifyError('pools:apn.' + data.message.message, dispatch);
                    }
                },
            },
            { dispatchAfterCallback: false, propagateDataToCallback: true }
        );
    };

    return (
        <Dialog open={open} onClose={closed} maxWidth={'sm'} fullWidth={true}>
            <DialogTitle>
                <I18n trans={isPublic ? 'pools:apn.new_apn_name_public' : 'pools:apn.new_apn_name_private'} />
            </DialogTitle>
            <DialogContent>
                <GridContainer>
                    <GridItem xs={12}>
                        <CustomInputExt
                            fullWidth={true}
                            labelText="pools:apn.apn_name"
                            onChange={(event: React.FormEvent<HTMLInputElement>): void => {
                                setApnName(event.currentTarget.value);
                            }}
                            value={apnName}
                        />
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={closed} callbackParam={{}} size={'sm'} label="general:common.cancel" />
                <CustomTextButtom callback={addNew} callbackParam={{}} size={'sm'} label="general:common.add_new" />
            </DialogActions>
        </Dialog>
    );
};
